import { useMemo } from 'react';

import { CAR_EMISSION_TYPES } from '../constants';

export const useCarEmissionTypeList = () => {
  return useMemo(() => ([
    {
      value: "Euro 1",
      key: CAR_EMISSION_TYPES.euro1,
    },
    {
      value: "Euro 2",
      key: CAR_EMISSION_TYPES.euro2,
    },
    {
      value: "Euro 3",
      key: CAR_EMISSION_TYPES.euro3,
    },
    {
      value: "Euro 4",
      key: CAR_EMISSION_TYPES.euro4,
    },
    {
      value: "Euro 5",
      key: CAR_EMISSION_TYPES.euro5,
    },
    {
      value: "Euro 6",
      key: CAR_EMISSION_TYPES.euro6,
    }
  ]), []);
};
